<template>
  <div class="eventComp_mode_18 eventComp_mode_container" v-show="currThemeObj">
    <div class="tableScrollArea" ref="tableParentDom">
      <el-tabs
        v-model="tabActiveKey"
        type="card"
        @tab-click="handleClickTab"
        v-if="roundGroup && roundGroup.length > 0"
      >
        <el-tab-pane
          :label="round.tabName"
          :name="round.tabKey"
          v-for="round in roundGroup"
          :key="round.tabKey"
        >
          <div
            class="groupTable_item"
            v-for="group in round.groupTable"
            :key="group.groupKey"
            :ref="group.refName"
            :style="{
              height: `${
                group.isOpenFlag
                  ? group.clientHeightPx
                    ? group.clientHeightPx + 'px'
                    : 'auto'
                  : '3.47vw'
              }`,
            }"
          >
            <div class="groupTable_titleRow">
              <span class="titleRow_title" v-text="group.groupName"></span>
              <span class="groupTable_head_arrow">
                <span class="arrowIcon">
                  <span
                    @click="isTableAllExpand(group, round.tabKey)"
                    class="el-icon el-icon-arrow-right"
                    :class="group.isOpenFlag ? 'open' : ''"
                  ></span>
                </span>
              </span>
            </div>
            <multiLevelFold_table
              :currThemeObj="currThemeObj"
              :currCid="currCid"
              :currSid="currSid"
              :tableMode="tableMode"
              :parentWidthPx="parentWidthPx"
              :isScrollFlag="isScrollFlag"
              :variableColWidthVw="variableColWidthVw"
              :tableCellDefaultWidthVw="tableCellDefaultWidthVw"
              :defaultWidthVwNum="group.defaultWidthVwNum"
              :tableColumnData="group.tableColumnData"
              :tableData="group.tableData"
              :expandKey="expandKey"
              :isExpandAll="isExpandAll"
              @toParentEvent="toParentEventHandler"
              v-show="group.tableData && group.tableData.length > 0"
            ></multiLevelFold_table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="note_box" v-show="annotationList && annotationList.length > 0">
      <span class="note_title" v-text="'注释'"></span>
      <span class="note_info">
        <span
          class="noteInfo_item"
          v-for="(item, index) in annotationList"
          :key="index"
          v-text="`${item.name}：${item.explain}`"
        ></span>
      </span>
    </div>
  </div>
</template>

<script>
// 适用： 表格上面带tab切换的[表格不带展开行，但组带展开]  体操（轮次成绩 和 出场名单）
import multiLevelFold_table from '@components/platfromBase/compreSportsMeet/table/multiLevelFold_table.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'eventComp_mode_18',
  components: {
    multiLevelFold_table,
  },
  props: {
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    datas: {
      type: [Array, Object],
      default: null,
    },
    tabType: {
      type: String, //确定数据来自于 出场名单'startList'  ||【 本场数据'localData' || 轮次成绩'roundResult' ||  单项成绩'singleResult' || 团体成绩 'teamResult' || 全能成绩'combinedResult'】,
      default: '',
    },
    competitorType: {
      type: String,
      default: '', // A || D || T
    },
  },
  mixins: [cup_base_data_mixin],
  watch: {
    datas: {
      handler(newVal, oldVal) {
        console.debug('mode_18 刷新数据:', newVal, oldVal)
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          this.init()
        }
      },
      //   immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      isScrollBottom: false,
      tableMode: 'eventComp_mode_18',
      parentWidthPx: 0,
      parentHeightPx: 0,
      isScrollFlag: false,
      isClickFlag: false,
      variableColWidthVw: null,
      tableCellDefaultWidthVw: 5.55, //默认列的宽度决定了展开行箭头占得宽度，因此这个最好不要动；如果需要处理某个单独列的宽度时，单独赋值
      expandCellDefaultWidthVw: 5.55,
      defaultWidthVwNum: null,
      annotationList: [],
      roundGroup: [],
      expandKey: '',
      isExpandAll: false, //只要需要expand属性默认都是展开，这个只是控制显示的高度
      tabActiveKey: '',
      currModeObj: null,
      renderModeList: [
        {
          isDatasType: 'Array',
          modeNameArr: [],
          tableCellDefaultWidthVw: 11.1,
          variableColWidthVw: [],
          sportsIdArr: ['GAR'], //体操
          resultKeyArr: [],
          isCompetitorTypeArr: ['A', 'T'],
          tabTypeArr: ['startList'],
        },
        {
          isDatasType: 'Object',
          modeNameArr: [],
          tableCellDefaultWidthVw: 6.94,
          variableColWidthVw: [],
          sportsIdArr: ['GAR'], //体操
          resultKeyArr: ['result_round'],
          isCompetitorTypeArr: ['A', 'T'],
          tabTypeArr: ['groupResult'],
        },
      ],
    }
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.onResizeEvent()
    })
    this.init()
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.onResizeEvent()
    })
  },
  methods: {
    async init() {
      this.$nextTick(() => {
        this.onResizeEvent()
        if (this.currSportsDetail && this.currSportsDetail.sportsId) {
          this.renderModeList.forEach((modeItem) => {
            if (
              modeItem.sportsIdArr.includes(this.currSportsDetail.sportsId) &&
              modeItem.isCompetitorTypeArr.includes(this.competitorType) &&
              modeItem.tabTypeArr.includes(this.tabType)
            ) {
              this.currModeObj = modeItem
            }
          })
        }
        console.debug(
          'mode_18 this.currModeObj',
          this.currModeObj,
          this.tabType,
          this.datas
        )
        if (this.currModeObj) {
          // let i = this.currModeObj.tabTypeArr.indexOf(this.tabType)
          const data = this.datas
          // if (data.annotation) {
          //   this.annotationList = data.annotation
          // }
          if (this.currModeObj.isDatasType === 'Object') {
            let ind = this.currModeObj.tabTypeArr.indexOf(this.tabType)
            console.debug(ind)
            this.computedModeData(
              JSON.parse(
                JSON.stringify(data[this.currModeObj.resultKeyArr[ind]])
              )
            )
          } else {
            this.computedModeData(JSON.parse(JSON.stringify(data)))
          }
        }
      })
    },
    handleClickTab(tab, event) {
      console.debug(tab, event)
      this.$nextTick(() => {
        this.getCurRoundTableHeight(tab.paneName)
      })
    },
    toParentEventHandler(data) {
      console.debug(data)
    },
    onResizeEvent() {
      if (this.$refs.tableParentDom) {
        this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      } else {
        console.debug('dom 不存在')
      }
    },
    computedModeData(data) {
      console.debug('mode_18 computedModeData:', data)
      // const needAddEmptyColumnNameArr = ['运动员', '国家/地区'] //当table_head第一列的name属于其中之一，则要插入一个占位的空列
      if (
        ['startList', 'groupResult'].includes(this.tabType) &&
        data &&
        data.length > 0
      ) {
        this.roundGroup = data.map((round, roundIndex) => {
          if (round.round_detail) {
            let tableNumTotal = round.round_detail
              ? round.round_detail.length
              : 0
            let groupTable = round.round_detail.map((group, groupIndex) => {
              const table_headArr = group.table_head
              let defaultWidthVwNum = 0
              let tableColumnData = []

              // 表头
              const headColumns = []
              let deletColumnNum = 0
              table_headArr.forEach((colums, colIndex) => {
                // if (colIndex === 0) {
                //   if (needAddEmptyColumnNameArr.includes(colums.name)) {
                //     // 当运动员排在第一列是，需要增加一列空的
                //     headColumns.push({
                //       colKey: 'ranking',
                //       colTitle: '',
                //     })
                //   }
                // }
                if (colums && colums.map_key_arr.length > 0) {
                  headColumns.push({
                    colKey: colums.map_key_arr[0] ? colums.map_key_arr[0] : '',
                    colTitle: colums.name ? colums.name : '',
                  })
                }
              })

              let customColumn = {}
              if (this.currModeObj.tableCellDefaultWidthVw) {
                this.tableCellDefaultWidthVw =
                  this.currModeObj.tableCellDefaultWidthVw
              }
              let widthVw = this.tableCellDefaultWidthVw
              const otherColumns = headColumns

              if (this.competitorType === 'A') {
                // 体操 单人
                if (tableColumnData.length == 0) {
                  deletColumnNum++
                  customColumn = {
                    prop: 'playerName-playerLogo-playerGender-teamLogo-teamName', //fristColumnPropArr.join('-'),
                    label: '运动员',
                    // widthVw:
                    //   this.currModeObj.variableColWidthVw[
                    //     this.currModeObj.sportsIdArr.indexOf(
                    //       this.currSportsDetail.sportsId
                    //     )
                    //   ], //对应列的宽度，单位vw
                    className: 'columnPlayerGroupClass', //单独定制的头部样式class
                    // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
                  }
                }
              } else if (this.competitorType === 'T') {
                // 体操 团体

                // const otherColumns = headColumns
                if (tableColumnData.length == 0) {
                  deletColumnNum++
                  customColumn = {
                    prop: 'teamLogo-teamName', //fristColumnPropArr.join('-'),
                    label: '国家/地区',
                    // widthVw: this.variableColWidthVw, //对应列的宽度，单位vw
                    className: 'columnTeamLogoTeamNameClass', //单独定制的头部样式class
                    // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
                  }
                }
              }

              for (let i = 0; i < otherColumns.length; i++) {
                const item = otherColumns[i]
                if (['运动员', '姓名', '国家/地区'].includes(item.colTitle)) {
                  // 特殊列
                  tableColumnData.push(customColumn)
                } else {
                  tableColumnData.push({
                    prop: item.colKey,
                    label: item.colTitle,
                    widthVw: ['arrowIcon', 'isExpand'].includes(item.colKey)
                      ? this.expandCellDefaultWidthVw / 2
                      : widthVw, //单独设置 [arrowIcon, isExpand] 的对应列的宽度，单位vw, 宽度为普通的一半
                    className: ['arrowIcon', 'isExpand'].includes(item.colKey)
                      ? 'expandTdClassName'
                      : '', //单独定制的头部样式class
                    selected: '',
                  })
                }
                // if (i == 0) {
                //   tableColumnData.push(customColumn)
                // }
              }
              defaultWidthVwNum = tableColumnData.length - deletColumnNum //减去这3列[playerName-playerLogo-playerGender-teamLogo-teamName, arrowIcon, isExpand]
              console.debug('tableColumnData:', tableColumnData)

              let tableData = group.data
                ? group.data.map((rowData) => {
                    return rowData
                  })
                : []
              return {
                groupKey: `groupTable_${groupIndex}`,
                groupName: group.group_name,
                refName: `round_${roundIndex}_${groupIndex}`,
                isOpenFlag: true,
                tableData,
                tableColumnData,
                defaultWidthVwNum,
              }
            })
            return {
              tabKey: `round_${roundIndex}`,
              tabName: round.round_name,
              groupTable,
              tableNumTotal,
              isGetDomHeight: false,
            }
          } else {
            return {
              tabKey: 'undefinedKey',
              tabName: '未定义',
              groupTable: [],
              tableNumTotal: 0,
              isGetDomHeight: false,
            }
          }
        })

        if (this.roundGroup.length > 0) {
          this.tabActiveKey = this.roundGroup[0].tabKey
          this.getCurRoundTableHeight(this.tabActiveKey)
        }
        // this.$refs.tableParentDom.scrollTo(0, 0)
        console.debug('this.roundGroup:', this.roundGroup)
      } else {
        console.debug('暂无数据')
        this.notDataHandler()
      }
    },
    notDataHandler() {
      this.roundGroup = []
    },
    getCurRoundTableHeight(tabKey) {
      // 计算当前 tab 的每一个groupTable的高度
      console.debug(tabKey)
      this.$nextTick(() => {
        let roundGroup = this.roundGroup
        this.roundGroup = roundGroup.map((roundItem) => {
          if (!roundItem.isGetDomHeight && tabKey === roundItem.tabKey) {
            roundItem.groupTable.forEach((groupItem) => {
              const groupDom = this.$refs[`${groupItem.refName}`][0]
              if (!groupItem.clientHeightPx) {
                groupItem.clientHeightPx = groupDom.clientHeight
              }
            })
            roundItem.isGetDomHeight = true
          }
          return roundItem
        })
        console.debug(this.roundGroup)
        this.$forceUpdate()
      })
    },
    isTableAllExpand(group, roundKey) {
      console.debug(this.roundGroup, group, roundKey)
      const groupDom = this.$refs[`${group.refName}`][0]
      console.debug(group, groupDom, groupDom.clientHeight)
      if (groupDom && groupDom.clientHeight) {
        this.roundGroup.forEach((roundItem) => {
          if (roundItem.tabKey === roundKey) {
            roundItem.groupTable.forEach((groupItem) => {
              if (groupItem.groupKey === group.groupKey) {
                if (!groupItem.clientHeightPx) {
                  groupItem.clientHeightPx = groupDom.clientHeight
                }
                console.debug('ok', groupItem)
                group.isOpenFlag = !group.isOpenFlag
              }
            })
          }
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.eventComp_mode_container {
  padding: 1.388vw 0;
  .tableScrollArea {
    position: relative;
    width: 100%;
    .groupTable_item {
      width: 100%;
      transition: height 0.3s linear;
      overflow: hidden;
      .groupTable_titleRow {
        position: relative;
        width: 100%;
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        align-items: center;
        height: 3.47vw;
        background-color: var(--mixtmt_table_headerBg);
        color: var(--mixtmt_table_headerColor);
        border-bottom: 1px solid var(--mixtmt_whiteColor);
        .titleRow_title {
          padding-left: 1.388vw;
          font-size: 1.388vw;
          font-weight: bold;
        }
        .groupTable_head_arrow {
          width: 4.16vw;
          position: absolute;
          top: 0;
          right: 0;
          z-index: 10;
          height: 3.332vw;
          color: var(--mixtmt_whiteColor);
          .arrowIcon {
            width: 100%;
            /* position: relative; */
            display: block;
            &:hover {
              cursor: pointer;
            }
            .el-icon-arrow-right {
              position: absolute;
              top: 0;
              right: 0;
              z-index: 2;
              width: 100%;
              height: 100%;
              display: flex;
              display: -webkit-flex;
              justify-content: center;
              align-items: center;
              transition: transform 0.2s linear;
              &.open {
                transform: rotate(90deg);
              }
              &:before {
                content: '\e6e0';
              }
            }
          }
        }
      }
    }
  }
  .note_box {
    width: 100%;
    padding: 0.694vw 1.338vw 4.16vw;
    /* border-top: 1px solid var(--mixtmt_greyColor8); */
    .note_title {
      display: block;
      font-size: 1.11vw;
      color: var(--mixtmt_mainColor);
      line-height: 2.083vw;
      font-weight: bold;
    }
    .note_info {
      width: 100%;
      padding: 0 0.694vw 0 0;
      height: auto;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      .noteInfo_item {
        width: auto;
        min-width: 12.5%;
        text-align: left;
        font-size: 1.11vw;
        line-height: 2.5vw;
        color: var(--mixtmt_greyColor2);
        padding-left: 1.388vw;
        &:first-child {
          padding-left: 0.694vw;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.mixtmt_pc {
  .eventComp_mode_container {
    .el-tabs__item:hover {
      cursor: pointer;
    }
  }
}
.eventComp_mode_container {
  .el-tabs--card > .el-tabs__header .el-tabs__nav {
    border-radius: 0.416vw 0.416vw 0 0;
    border-color: var(--mixtmt_table_headerBg);
    overflow: hidden;
  }
  .el-tabs__item {
    padding: 0 1.388vw;
    height: 2.788vw;
    line-height: 2.788vw;
    font-size: 1.11vw;
    min-width: 6.94vw;
    text-align: center;
    color: var(--mixtmt_greyColor6);
  }
  .el-tabs--card > .el-tabs__header .el-tabs__item {
    transition: none;
  }
  .el-tabs--card > .el-tabs__header .el-tabs__item {
    border-left: 1px solid var(--mixtmt_table_headerBg);
  }
  .el-tabs--card > .el-tabs__header .el-tabs__item:first-child {
    border-left: none;
  }
  .el-tabs__header {
    margin: 0;
  }
  .el-tabs__item.is-active,
  .el-tabs__item.is-active:hover,
  .el-tabs__item:hover {
    background-color: var(--mixtmt_table_headerBg);
    color: var(--mixtmt_table_headerColor);
  }
  .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    border-color: var(--mixtmt_table_headerBg);
  }

  .el-tabs--bottom
    .el-tabs--left
    > .el-tabs__header
    .el-tabs__item:nth-child(2),
  .el-tabs--bottom
    .el-tabs--right
    > .el-tabs__header
    .el-tabs__item:nth-child(2),
  .el-tabs--bottom.el-tabs--border-card
    > .el-tabs__header
    .el-tabs__item:nth-child(2),
  .el-tabs--bottom.el-tabs--card > .el-tabs__header .el-tabs__item:nth-child(2),
  .el-tabs--top .el-tabs--left > .el-tabs__header .el-tabs__item:nth-child(2),
  .el-tabs--top .el-tabs--right > .el-tabs__header .el-tabs__item:nth-child(2),
  .el-tabs--top.el-tabs--border-card
    > .el-tabs__header
    .el-tabs__item:nth-child(2),
  .el-tabs--top.el-tabs--card > .el-tabs__header .el-tabs__item:nth-child(2) {
    padding-left: 1.388vw;
  }
  .el-cascader-menu:last-child .el-cascader-node,
  .el-tabs--bottom .el-tabs--left > .el-tabs__header .el-tabs__item:last-child,
  .el-tabs--bottom .el-tabs--right > .el-tabs__header .el-tabs__item:last-child,
  .el-tabs--bottom.el-tabs--border-card
    > .el-tabs__header
    .el-tabs__item:last-child,
  .el-tabs--bottom.el-tabs--card > .el-tabs__header .el-tabs__item:last-child,
  .el-tabs--top .el-tabs--left > .el-tabs__header .el-tabs__item:last-child,
  .el-tabs--top .el-tabs--right > .el-tabs__header .el-tabs__item:last-child,
  .el-tabs--top.el-tabs--border-card
    > .el-tabs__header
    .el-tabs__item:last-child,
  .el-tabs--top.el-tabs--card > .el-tabs__header .el-tabs__item:last-child {
    padding-right: 1.388vw;
  }
}
</style>
